import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock3 } from "lucide-react";
import { api } from "../../../services/apiService";
import { paymentError } from "../../../components/payments/paymentUtils";
import { CheckoutHeader } from "../components/CheckoutHeader";

export function CheckoutSuccessPage() {
  const [params] = useSearchParams();
  const reference = params.get("reference");
  const [checkout, setCheckout] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!reference) { setError("Payment reference is missing."); return undefined; }
    let active = true; let attempts = 0; let timer;
    const poll = async () => {
      try { const response = await api.get(`/checkout/reference/${encodeURIComponent(reference)}`); if (!active) return; setCheckout(response.data.checkout); setError(""); if (response.data.checkout.status !== "paid" && attempts++ < 10) timer = setTimeout(poll, 2500); }
      catch (err) { if (active) setError(paymentError(err, "We could not check confirmation yet. Your payment record is still safe.")); }
    };
    poll(); return () => { active = false; clearTimeout(timer); };
  }, [reference]);
  const confirmed = checkout?.status === "paid";
  return <main className="checkout-wrap"><CheckoutHeader /><div className="ops-card auth-status" aria-live="polite">
    <div className={`auth-status-icon ${confirmed ? "" : "is-pending"}`}>{confirmed ? <CheckCircle2 size={26} /> : <Clock3 size={26} />}</div>
    <h1 className="ops-header-title">{confirmed ? "Payment confirmed" : "Confirming your payment"}</h1>
    {confirmed ? <p>{checkout.player?.firstName} is enrolled in <strong>{checkout.plan?.name}</strong>. Reference <strong>{checkout.reference}</strong>.</p> : <p>{error || "Stripe has returned you safely. We’re waiting for the secure confirmation before activating enrollment—this usually takes only a moment."}</p>}
    <div className="ops-form-actions"><Link to="/dashboard/payments" className="ops-button ops-button--primary">View payment center</Link>{confirmed && <Link to="/dashboard/membership" className="ops-button ops-button--secondary">View membership</Link>}</div>
  </div></main>;
}
